import { useEffect, useState } from "react";

// ---------------------------------------------------------------------------
// true unter 768 px (Tailwinds `md`). Das Handy-Web folgt dort der App-Optik,
// Tablet und Desktop bleiben unverändert (Entscheidung 01.10.2026).
//
// Nur einsetzen, wo das MARKUP verschieden sein muss (anderer Inhalt, anderes
// Verhalten). Reine Optik regeln Tailwind-Klassen mit `md:` — die brauchen
// kein JavaScript und flackern nicht beim ersten Rendern.
// ---------------------------------------------------------------------------
const ABFRAGE = "(max-width: 767px)";

export default function useIsPhone() {
  const [phone, setPhone] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(ABFRAGE).matches
      : false,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia(ABFRAGE);
    const onChange = () => setPhone(mq.matches);
    onChange();
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return phone;
}
